import React from 'react'
import {
  Box,
  Grid,
} from '@material-ui/core'
import { Stack, Checkbox, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { DatePicker } from './form/DateTimePicker'
import { GalleryFormFieldLabel } from './GalleryFormFieldLabel'

export const GalleryDateFormField = ({
  control,
  classes,
  isEditorForPhotoArt
}) => {
  
  const labelStyling = {
    width: 130,
    fontWeight: 600,
    fontSize: 12,
    color: '#606060',
    display: 'flex',
    alignItems: 'center'
  }

  const inputStyling = {
    padding: '0px 10px',
    background: '#ebebeb',
    width: 253,
    height: 25,
    fontWeight: 400,
    fontSize: 12,
    color: '#606060'
  }
  
  return (
    <Grid item xs={ 12 }>
      <Box sx={{ display: 'flex', gap: '10px', width: '100%' }}>
        <GalleryFormFieldLabel label={ isEditorForPhotoArt ? 'Date Taken' : 'Date' }/>
        <Typography sx={inputStyling}>
          <Controller
            name='shot_at_date'
            control={ control }
            render={(fieldProps) => (
              <Box>
                <span classname={ classes.placeHolderSize }>
                  <DatePicker
                    autoOk
                    classes={ classes }
                    fieldProps={ fieldProps }
                    className={ classes.gallery_activity_form_field }
                  />
                </span>
              </Box>
            )}
          />
        </Typography>
      </Box>
    </Grid>
  )
}
